export const changeLongitudeReducer = (state = null, action) => {
  switch (action.type) {
    case "CHANGE_LONGITUDE":
      return action.payload.longitude;
    default:
      return state;
  }
};
